import styles from './Auth.module.css';
import SubmitButton from './SubmitButton';
import { toast } from 'react-toastify';
import { useState, useEffect, useContext } from 'react';
import { invalidUrlError, validateUrl } from '../../utils/functions';
import { Context } from '../../AuthContext';

const SocialLinks = ({ user, userFromDb }) => {
  const [homepage, set_homepage] = useState(userFromDb?.homepage || '');
  const [LinkedIn, setLinkedin] = useState(userFromDb?.LinkedIn || '');
  const [ResearchGate, setResearchGate] = useState(userFromDb?.ResearchGate || '');
  const [GoogleScholar, setGoogleScholar] = useState(userFromDb?.GoogleScholar || '');
  const [ORCID, setORCID] = useState(userFromDb?.ORCID || '');
  const [BlueSky, setBlueSky] = useState(userFromDb?.BlueSky || '');
  const [resume, setResume] = useState(userFromDb?.resume || '');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    set_homepage(userFromDb?.homepage || '');
    setLinkedin(userFromDb?.LinkedIn || '');
    setResearchGate(userFromDb?.ResearchGate || '');
    setGoogleScholar(userFromDb?.GoogleScholar || '');
    setORCID(userFromDb?.ORCID || '');
    setBlueSky(userFromDb?.BlueSky || '');
    setResume(userFromDb?.resume || '');
  }, [userFromDb]);

  const submitForm = async (e) => {
    setSubmitting(true);
    e.preventDefault();

    const url = process.env.REACT_APP_FLASK_WEBSERVER + 'edit_user';

    const data = {
      homepage,
      LinkedIn,
      ResearchGate,
      GoogleScholar,
      ORCID,
      BlueSky,
      resume,
    };

    try {
      const token = await user.getIdToken();
      const res = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (res.status === 200) {
        toast.success('Social links updated successfully!', {
          className: 'toast',
          autoClose: 3000,
        });
      } else {
        toast.error('Unable to update social links', {
          className: 'toast',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Error updating social links', {
        className: 'toast',
        autoClose: 3000,
      });
      console.error('Error updating social links:', error);
    }

    setSubmitting(false);
  };

  return (
    <form
      onSubmit={submitForm}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        textAlign: 'left',
        width: '400px',
      }}
    >
      <div>
        <label className={styles['input-label']}>Personal Website</label>
        <input
          className={styles['input-text']}
          type="text"
          id="homepage"
          name="homepage"
          value={homepage}
          onChange={(e) => set_homepage(e.target.value)}
          placeholder="https://profiles.stanford.edu/jackson"
          pattern={validateUrl}
          title={invalidUrlError}
        />
      </div>
      <div>
        <label className={styles['input-label']}>LinkedIn</label>
        <input
          className={styles['input-text']}
          type="text"
          id="LinkedIn"
          name="linkedIn"
          value={LinkedIn}
          onChange={(e) => setLinkedin(e.target.value)}
          placeholder="https://linkedIn.com/in/yourprofile"
          pattern={validateUrl}
          title={invalidUrlError}
        />
      </div>
      <div>
        <label className={styles['input-label']}>Research Gate</label>
        <input
          className={styles['input-text']}
          type="text"
          id="ResearchGate"
          name="ResearchGate"
          value={ResearchGate}
          onChange={(e) => setResearchGate(e.target.value)}
          placeholder="https://researchgate.net/profile/yourname"
          pattern={validateUrl}
          title={invalidUrlError}
        />
      </div>
      <div>
        <label className={styles['input-label']}>Google Scholar</label>
        <input
          className={styles['input-text']}
          type="text"
          id="GoogleScholar"
          name="GoogleScholar"
          value={GoogleScholar}
          onChange={(e) => setGoogleScholar(e.target.value)}
          placeholder="https://scholar.google.com/citations?user=yourid"
          pattern={validateUrl}
          title={invalidUrlError}
        />
      </div>
      <div>
        <label className={styles['input-label']}>ORCID</label>
        <input
          className={styles['input-text']}
          type="text"
          id="ORCID"
          name="ORCID"
          value={ORCID}
          onChange={(e) => setORCID(e.target.value)}
          placeholder="https://orcid.org/0000-0000-0000-0000"
          pattern={validateUrl}
          title={invalidUrlError}
        />
      </div>
      <div>
        <label className={styles['input-label']}>BlueSky</label>
        <input
          className={styles['input-text']}
          type="text"
          id="BlueSky"
          name="BlueSky"
          value={BlueSky}
          onChange={(e) => setBlueSky(e.target.value)}
          placeholder="https://bsky.app/profile/mcuban.bsky.social"
          pattern={validateUrl}
          title={invalidUrlError}
        />
      </div>
      <div>
        <label className={styles['input-label']}>CV/Resume</label>
        <input
          className={styles['input-text']}
          type="text"
          id="resume"
          name="resume"
          value={resume}
          onChange={(e) => setResume(e.target.value)}
          pattern={validateUrl}
          title={invalidUrlError}
          placeholder="https://cap.stanford.edu/profiles/viewCV?facultyId=48949&name=Rob_Jackson"
        />
      </div>

      <div style={{ paddingTop: '20px' }}>
        <SubmitButton
          text="Save Links"
          disabled={submitting}
          width="100%"
          height="40px"
          fontSize="14px"
          fontWeight="400"
        />
      </div>
    </form>
  );
};

const MyLinks = () => {
  const [userFromDb, setUserFromDb] = useState('');
  const { user, authLoading } = useContext(Context);

  useEffect(() => {
    if (authLoading) return;

    document.title = 'Profile - The Simple Platform';
    const getUser = async () => {
      const userFromDb = await fetchUser();
      setUserFromDb(userFromDb);
    };
    getUser();
  }, [user, authLoading]);

  const fetchUser = async () => {
    const token = await user.getIdToken();
    const url = process.env.REACT_APP_FLASK_WEBSERVER + 'get_user';
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const userData = await res.json();
    return userData;
  };

  return (
    <div style={{ width: '75vw' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>My Profiles</h2>
      </div>
      <SocialLinks user={user} userFromDb={userFromDb} />
    </div>
  );
};

export default MyLinks;
